import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { FastViLogo } from "./FastViLogo";

/**
 * Full-screen branded splash shown once per page load.
 * - Fixed duration — never waits on network/auth
 * - Layered above everything; the real app mounts underneath immediately
 * - Honours prefers-reduced-motion with a static logo + fast fade
 */
export function SplashScreen() {
  const reduced = useReducedMotion();
  const [done, setDone] = useState(false);

  useEffect(() => {
    const total = reduced ? 450 : 1550; // ms before the splash slides out
    const t = setTimeout(() => setDone(true), total);
    return () => clearTimeout(t);
  }, [reduced]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          key="fastvi-splash"
          className="fixed inset-0 z-[9999] grid place-items-center bg-background"
          initial={{ opacity: 1 }}
          exit={reduced
            ? { opacity: 0, transition: { duration: 0.2 } }
            : { opacity: 0, y: -16, transition: { duration: 0.42, ease: [0.65, 0, 0.35, 1] } }}
          data-testid="fastvi-splash"
        >
          <motion.div
            initial={reduced ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.82 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={reduced
              ? { duration: 0.15 }
              : { duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col items-center gap-6"
          >
            <FastViLogo size={200} animatedGlow={!reduced} />
            <motion.div
              initial={reduced ? { opacity: 1 } : { opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: reduced ? 0 : 0.55, duration: 0.4 }}
              className="text-[11px] font-mono uppercase tracking-[0.35em] text-muted-foreground"
              data-testid="fastvi-splash-tag"
            >
              Secure Intercom
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default SplashScreen;
